import { render, staticRenderFns } from "./Cmodal.vue?vue&type=template&id=4639a7a0&"
import script from "./Cmodal.vue?vue&type=script&lang=js&"
export * from "./Cmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports